// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket_wrapper {
  padding: 20px;
  padding-top: 5px;
  box-sizing: border-box;
}
.ticket_wrapper .ticket {
  background: rgba(244, 171, 115, 0.08);
  border: 2px dotted #dadada;
  border-left: 5px solid #dbb49f;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 3px;
  color: #c5a285;
}
.ticket_wrapper .card_grid {
  display: inline-flex;
}

h1 {
  margin: 0;
  margin-bottom: 20px;
}

.track_btn {
  width: 100%;
  padding: 10px;
  background: #dbb49f;
  color: #fff;
  border-radius: 4px;
  text-align: left;
  line-height: 30px;
  margin-bottom: 5px;
  cursor: pointer;
  display: inline-flex;
  justify-content: space-between;
}
.track_btn ion-icon {
  font-size: 19px;
  margin-left: 10px;
  margin-top: 6px;
}

.hollow {
  font-weight: 900;
  border: 2px solid #dbb49f;
  color: #dbb49f;
  background: none;
}

.track_red_btn {
  background: rgb(231, 126, 126);
}

.no_ticket_wrapper {
  color: #cfb5a6;
  font-size: 14px;
  text-align: center;
  width: 60%;
  margin-top: 30%;
  margin-left: auto;
  margin-right: auto;
}

.phased {
  opacity: 0.5;
}

.cost_brick ul {
  list-style: none;
  padding: 0;
}

.deliverTutBtn {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding: 12px;
  width: 100%;
  margin-bottom: 40px;
  color: #fff;
  font-size: 14px;
  font-weight: 800;
  background: #e9b3a3;
}
.deliverTutBtn ion-icon {
  margin-left: 30px;
  font-size: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/orders/orders.page.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,gBAAA;EACA,sBAAA;AACJ;AACI;EACI,qCAAA;EACA,0BAAA;EACA,8BAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;AACR;AAEI;EACI,oBAAA;AAAR;;AAIA;EACI,SAAA;EACA,mBAAA;AADJ;;AAIA;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EAEA,oBAAA;EACA,8BAAA;AAFJ;AAII;EACI,eAAA;EACA,iBAAA;EACA,eAAA;AAFR;;AAMA;EACI,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAHJ;;AAOA;EACI,8BAAA;AAJJ;;AAOA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAQI;EACI,gBAAA;EACA,UAAA;AALR;;AASA;EACI,cAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EAEA,WAAA;EACA,mBAAA;EAEA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AARJ;AAUI;EACI,iBAAA;EACA,eAAA;AARR","sourcesContent":[".ticket_wrapper {\n    padding: 20px;\n    padding-top: 5px;\n    box-sizing: border-box;\n\n    .ticket {\n        background: rgb(244 171 115 / 8%);\n        border: 2px dotted #dadada;\n        border-left: 5px solid #dbb49f;\n        padding: 20px;\n        margin-bottom: 20px;\n        border-radius: 3px;\n        color: #c5a285;\n    }\n\n    .card_grid {\n        display: inline-flex;\n    }\n}\n\nh1 {\n    margin: 0;\n    margin-bottom: 20px;\n}\n\n.track_btn {\n    width: 100%;\n    padding: 10px;\n    background: #dbb49f;\n    color: #fff;\n    border-radius: 4px;\n    text-align: left;\n    line-height: 30px;\n    margin-bottom: 5px;\n    cursor: pointer;\n\n    display: inline-flex;\n    justify-content: space-between;\n\n    ion-icon {\n        font-size: 19px;\n        margin-left: 10px;\n        margin-top: 6px;\n    }\n}\n\n.hollow {\n    font-weight: 900;\n    border: 2px solid #dbb49f;\n    color: #dbb49f;\n    background: none;\n}\n\n\n.track_red_btn {\n    background: rgb(231, 126, 126);\n}\n\n.no_ticket_wrapper {\n    color: #cfb5a6;\n    font-size: 14px;\n    text-align: center;\n    width: 60%;\n    margin-top: 30%;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.phased {\n    opacity: 0.5;\n}\n\n.cost_brick {\n    ul {\n        list-style: none;\n        padding: 0;\n    }\n}\n\n.deliverTutBtn {\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n    padding: 12px;\n\n    width: 100%;\n    margin-bottom: 40px;\n\n    color: #fff;\n    font-size: 14px;\n    font-weight: 800;\n    background: #e9b3a3;\n\n    ion-icon {\n        margin-left: 30px;\n        font-size: 16px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
